import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { APIURL, TZ } from '../../../../Global';
import sampleList from '../sampleList';
import { useAlert } from 'react-alert';
import { FaCheck, FaTimes } from 'react-icons/fa';

const AddItem = ({ group, handleSuccess, type, onClose }) => {
    const [sample, setSample] = useState('blood');
    const [selectedItems, setSelectedItems] = useState([]);
    const [options, setOptions] = useState([]);
    const alert = useAlert();

    useEffect(() => {
        if (sample) {
            const tokenString = sessionStorage.getItem('usertoken');
            const str = tokenString.replace(/["]+/g, '');
            axios
                .get(`${APIURL}/api/v1/staff/lab-test/?sample=${sample}&${TZ}`, {
                    headers: {
                        Authorization: 'Token ' + str,
                    },
                })
                .then((res) => {
                    if (res.status === 200 && res.data.status === 'success') {
                        let option = [];
                        if (type === 'panel') {
                            option = res.data.panels.map((panel) => ({
                                id: panel.id,
                                name: panel.panel_name,
                                sample: sample
                            }));
                        } else {
                            option = res.data.tests.map((test) => ({
                                id: test.id,
                                name: test.test_name,
                                sample: sample
                            }));
                        }
                        setOptions(option);
                    } else {
                        setOptions([])
                        alert.error(res.data.message || 'Error fetching tests.');
                    }
                })
                .catch((err) => {
                    alert.error('Error fetching sample data.');
                });
        }
    }, [sample, type, alert]);

    const handleCategoryClick = (category) => {
        setSample(category);
    };

    const handleSelectItem = (item) => {
        if (selectedItems.some(selected => selected.id === item.id)) {
            setSelectedItems(selectedItems.filter(selected => selected.id !== item.id));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };

    const handleRemoveItem = (itemId) => {
        setSelectedItems(selectedItems.filter(item => item.id !== itemId));
    };

    const handleSubmit = () => {
        if (!group || !group.id) {
            alert.error('Group is mandatory');
            return;
        }

        if (selectedItems.length === 0) {
            alert.error(`Please select at least one ${type}`);
            return;
        }

        const payload = {
            group_id: group.id,
            [type === 'panel' ? 'panels' : 'tests']: selectedItems.map(item => item.id),
        };

        const tokenString = sessionStorage.getItem('usertoken');
        const str = tokenString.replace(/["]+/g, '');

        axios.post(`${APIURL}/api/v1/staff/lab-test/?${TZ}`, payload, {
            headers: {
                Authorization: 'Token ' + str,
            },
        })
            .then((res) => {
                if (res.status === 200 && res.data.status === 'success') {
                    alert.success(`${type} added successfully!`);
                    handleSuccess();
                    onClose();
                } else {
                    alert.error(res.data.message || `Failed to add ${type}.`);
                }
            })
            .catch((err) => {
                alert.error(`Failed to add ${type}. Please try again.`);
            });
    };

    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            show={true}
            onHide={onClose}
        >
            <Modal.Body>
                <div className="add-cont colflex-display">
                    <label className="addcont-head" style={{ margin: 0 }}>{group.name}</label>
                    {group.description && <span style={{ color: '#000' }}>{group.description}</span>}
                    <hr style={{ border: "1px solid #ccc", margin: 0 }} />
                    <div className="additem-container">
                        <div className="samples-column" >
                            <div className="samples-header">Samples</div>
                            <div className="samples-list" style={{ borderRadius: 0, border: "none" }}>
                                {sampleList.map((category) => (
                                    <button
                                        key={category}
                                        className={`sample-button ${sample === category ? "active" : ""}`}
                                        onClick={() => handleCategoryClick(category)}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="items-column">
                            <div className="items-header">Available {type}s ({sample})</div>
                            <div className="items-list">
                                <div className="items-list">
                                    {options.length > 0 ? (
                                        options.map((item) => {
                                            const isSelected = selectedItems.some(selected => selected.id === item.id);
                                            return (
                                                <div
                                                    key={item.id}
                                                    className={`item-card ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => handleSelectItem(item)}
                                                >
                                                    <div className="item-content">
                                                        {item.name}
                                                    </div>
                                                    {isSelected && <FaCheck className="selected-icon" />}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="empty-message">No {type}s available for this sample</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="selected-column">
                            <div className="selected-header">Selected {type}s</div>
                            <div className="selected-list">
                                {selectedItems.length > 0 ? (
                                    selectedItems.map((item) => (
                                        <div key={item.id} className="selected-item">
                                            <span>
                                                {item.name}
                                                <span className="item-sample">{item.sample}</span>
                                            </span>
                                            <FaTimes
                                                className="remove-icon"
                                                onClick={() => handleRemoveItem(item.id)}
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <div className="empty-message">No {type}s selected</div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="action-buttons">
                        <button className='cancel-btn' onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            className='save-btn'
                            onClick={handleSubmit}
                            disabled={selectedItems.length === 0}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AddItem;